import { PropsWithChildren } from 'react';

import { Divider, Box } from '@cast/design-system';

import {
  sidebarTreeChildrenSx,
  sidebarTreeGroupSx,
  sidebarTreeLineSx,
} from './sidebarStyles';

export const SidebarTreeGroup = ({ children }: PropsWithChildren) => (
  <Box sx={sidebarTreeGroupSx}>
    <Box sx={sidebarTreeLineSx}>
      <Divider orientation="vertical" flexItem />
    </Box>
    <Box sx={sidebarTreeChildrenSx}>{children}</Box>
  </Box>
);
